<div id="layout" class="theme-cyan">

  <div class="authentication">

    <div class="container d-flex flex-column">

      <div class="row align-items-center justify-content-center no-gutters min-vh-100">

        <div class="col-12 col-md-7 col-lg-5 col-xl-4 py-md-11">

          <div class="card border-0 shadow-sm">
            <div class="card-body">
              <!-- Heading -->
              <h3 class="text-center">2-step Verification</h3>

              <!-- Text -->
              <p class="text-center mb-6">We sent a verification code to your email. Enter the code from the email in
                the field below.</p>

              <!-- Form -->
              <form class="mb-4 mt-5">
                <!-- Enter OTP -->
                <div class="input-group">
                  <input type="text" class="form-control form-control-lg text-center" placeholder="-">
                  <input type="text" class="form-control form-control-lg text-center" placeholder="-">
                  <input type="text" class="form-control form-control-lg text-center" placeholder="-">
                  <input type="text" class="form-control form-control-lg text-center" placeholder="-">
                </div>

                <!-- Submit -->
                <div class="text-center mt-5">
                  <a [routerLink]="['/dashboard']" href="javascript:void(0)" class="btn btn-lg btn-primary"
                    title="">Verify my account</a>
                </div>
              </form>

              <!-- Text -->
              <p class="text-center mb-0">Haven't received it? <a class="link" href="javascript:void(0);">Resend a new
                  code.</a>.</p>
            </div>
          </div>

        </div>

        <div class="signin-img d-none d-lg-block text-center">
          <img src="assets/images/signin-img-cyan.svg" alt="Sign In Image" />
        </div>

      </div> <!-- / .row -->

    </div>

  </div>

</div>
